import {
  Colors,
  Cross,
  Modal,
  ModalHr,
  Typography,
  TypographyWithIcon
} from '@giantleap/components-library'
import { CircularProgress } from '@material-ui/core'
import { functions } from 'config/firebase'
import * as React from 'react'
import ReactSVG from 'react-svg'
import SnackbarService from 'services/snackbars'
import CrossIcon from '../../assets/img/cross.svg'
import styles from './style.module.scss'
import { IProps, IState } from './types'

const revokeEducatorAccess = functions.httpsCallable('revokeEducatorAccess')

class TeachersModal extends React.Component<IProps, IState> {
  state: IState = {
    deletingTeacherId: null
  }
  async removeTeacher(childId: string, teacherId: string) {
    this.setState({ deletingTeacherId: teacherId })
    try {
      const revoke = await revokeEducatorAccess({
        educator_uid: teacherId,
        child_id: childId
      })
      if (revoke && revoke.data) {
        if (revoke.data.error) {
          SnackbarService.showSnackbar(revoke.data.error, 'error')
        } else {
          SnackbarService.showSnackbar('Educator is removed', 'success')
        }
      } else {
        SnackbarService.showSnackbar(
          'error occured while revoking teacher access. try again later',
          'error'
        )
      }
    } catch (error) {
      SnackbarService.showSnackbar(
        'error occured while revoking teacher access. try again later',
        'error'
      )
    }
    this.setState({ deletingTeacherId: null })
  }
  render() {
    const { open, setActive, childName, teachers, childId } = this.props

    return (
      <Modal
        active={open}
        setActive={setActive}
        baseClassName={styles.wrap}
        x={<Cross size="big" color={Colors.unselected} />}
      >
        <Typography
          type="title"
          size="big"
          className={styles.title}
          textAlign="left"
        >
          {childName}'s Techers
        </Typography>
        <Typography type="text" className={styles.text} textAlign="left">
          The following users have access to your child’s information. Click ‘x’
          to revoke permissions
        </Typography>
        <ModalHr />
        {teachers.map(({ name, id }, i) => (
          <TypographyWithIcon key={i} justifyContent="space-between">
            <Typography type="headline" size="small">
              {name}
            </Typography>
            {this.state.deletingTeacherId === id ? (
              <div className={styles.loading}>
                <CircularProgress
                  size={'2em'}
                  classes={{
                    circle: styles.loading__circle,
                    colorPrimary: `${styles.loading} ${styles.loading_primary}`
                  }}
                />
              </div>
            ) : (
              <span
                className={styles['cross-icon']}
                onClick={() => this.removeTeacher(childId, id)}
              >
                <ReactSVG src={CrossIcon} />
              </span>
            )}
          </TypographyWithIcon>
        ))}
      </Modal>
    )
  }
}

export default TeachersModal



// WEBPACK FOOTER //
// ./src/components/TeachersModal/index.tsx